/** @helpers */
export const obtainTeamFormEvents = (teamFormEvents = [], eventsNumber = 0) => {
  const teamFormEventsLength = teamFormEvents.length

  if (teamFormEventsLength <= eventsNumber) {
    for (let index = teamFormEventsLength; index < eventsNumber; index++) {
      teamFormEvents.push({
        eventId: `shadow-${index}`,
        result: '',
        status: '',
        against: null,
        type: 'shadow-event'
      })
    }

    return teamFormEvents
  }

  // Calculate the end index to exclude trailing shadow events
  let endIndex = teamFormEvents.length;

  // Use loop to find the first non-shadow event from the end
  for (let i = teamFormEvents.length - 1; i >= 0; i--) {
    if (teamFormEvents[i].type !== 'shadow-event') {
      endIndex = i + 1
      break
    }
  }

  let startIndex = Math.max(0, endIndex - eventsNumber)
  return teamFormEvents.slice(startIndex, endIndex)

  // old aproach
  // return teamFormEvents.slice(5 - eventsNumber, 6)
}

const defaultTrashHoldMS = 10 * 60 * 1000 // 10 minutes

export const shouldScheduleRefresh = (initial, thresholdInMilliseconds = defaultTrashHoldMS) => {
  const currentTimeTs = Date.now()
  const eventStartTimeTs = new Date(initial.startTime).getTime()
  const timeDifferenceTs = eventStartTimeTs - currentTimeTs

  const isBeforeGame = timeDifferenceTs >= 0 && timeDifferenceTs <= thresholdInMilliseconds

  return initial.isGameLive || isBeforeGame
}
